export default {
  title: '面试评估准则管理',
  menu: '面试评估准则管理',
  label: {
    company: '公司',
    groupName: '分组',
    criteria: '评估准则',
    status: '状态',
    activeCategory: '激活的分组',
    inactiveCategory: '禁用的分组',
    categoryTitle: '分组名称',
    addCategory: '添加分组',
    editCategory: '编辑分组',
    addQuestion: '添加面试评估准则',
    editQuestion: '编辑面试评估准则',
    content: '内容'
  },
  btn: {
    addQuestion: '新增面试评估准则',
    addCategory: '新增分组'
  },
  placeholder: {
    categoryStatus: '所有分组',
    keywords: '按分组搜索',
    categoryTitle: '请选择分组',
    categoryExist: '该分组已存在',
    content: '请输入内容',
    groupName: '请选择分组'
  }
}
